import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import Home from "@repo/core/screens/Home";
import Proposals from "@repo/core/screens/Proposals";
import { AuthLayout } from "../ui/components/layout/AuthLayout";
import { ROUTES } from "@repo/core/routes";
import { WebWelcome } from "../pages/Welcome";
import PreProposalsInfoSecurityScreen from "../pages/PreProposals/InfoSecurity";
import PreProposalsPhoneNumberScreen from "../pages/PreProposals/PhoneNumber";
import PreProposalsConfirmTokenScreen from "../pages/PreProposals/ConfirmToken";
import PreProposalsBiometryValidationScreen from "../pages/PreProposals/BiometryValidation";
import PreProposalsSelectProductScreen from "../pages/PreProposals/SelectProduct";
import PreProposalsSelectFinancialServiceScreen from "../pages/PreProposals/SelectFinancialService";
import PreProposalsSelectServicePointScreen from "../pages/PreProposals/SelectServicePoint";
import PreProposalsSelectAttendandScreen from "../pages/PreProposals/SelectAttendand";
import PreProposalsVerifyInformationsScreen from "../pages/PreProposals/VerifyInformations";
import PreProposalSelectDocuments from "../pages/PreProposals/SelectDocuments";
import PreProposalCaptureDocumentScreen from "../pages/PreProposals/CaptureDocument";

import Profile from "@repo/core/screens/Profile";
import EditProfile from "@repo/core/screens/EditProfile";
import Support from "@repo/core/screens/Support";
import ChangePassword from "@repo/core/screens/ChangePassword";
import Transactions from "@repo/core/screens/Transactions";
import Sales from "../pages/Sales";
import DetailsCreditProposal from "@repo/core/screens/ProposalEffectiveFlows/Credit/DetailsCreditProposal";

import CancelTransactionOptions from "@repo/core/screens/CancelTransactionOptions";
import CancelTransaction from "@repo/core/screens/CancelTransaction";
import SelectSecondCopyOfReceipt from "@repo/core/screens/SelectSecondCopyOfReceipt";
import SecondCopyOfReceipt from "@repo/core/screens/SecondCopyOfReceipt";
import ClosingOfTheDay from "@repo/core/screens/ClosingOfTheDay";
import EmergencyWithdrawOptions from "@repo/core/screens/EmergencyWithdraw/WithdrawOptions";
import EmergencyWithdraw from "@repo/core/screens/EmergencyWithdraw/Withdraw";
import EmergencyWithdrawConfirm from "@repo/core/screens/EmergencyWithdraw/WithdrawConfirm";
import EmergencyWithdrawReceipt from "@repo/core/screens/EmergencyWithdraw/WithdrawReceipt";
import ConsultLimitsVerifyIdentity from "@repo/core/screens/ConsultLimits/LimitsVerifyIdentity";
import ConsultLimitsReceipt from "@repo/core/screens/ConsultLimits/LimitsReceipt";
import InvoicePaymentOptions from "@repo/core/screens/InvoicePayment/InvoicePaymentOptions";
import InvoicePayment from "@repo/core/screens/InvoicePayment/InvoicePayment";
import ConfirmPayment from "@repo/core/screens/InvoicePayment/ConfirmPayment";
import InvoiceReceipt from "@repo/core/screens/InvoicePayment/InvoiceReceipt";

import SimulateInstallmentsOptions from "@repo/core/screens/SimulateInstallments/SimulateOptions";
import SimulateInstallmentsValue from "@repo/core/screens/SimulateInstallments/SimulateInstallmentsValue";
import SimulateInstallments from "@repo/core/screens/SimulateInstallments/SimulateInstallments";
import SimulateInstallmentsReceipt from "@repo/core/screens/SimulateInstallments/SimulateReceipt";

import PersonalDataForm from "@repo/core/screens/ProposalEffectiveFlows/Credit/PersonalDataForm";
import AddressDataForm from "@repo/core/screens/ProposalEffectiveFlows/Credit/AddressDataForm";
import ProfessionDataForm from "@repo/core/screens/ProposalEffectiveFlows/Credit/ProfessionDataForm";
import ReviewCreditProposal from "@repo/core/screens/ProposalEffectiveFlows/Credit/ReviewCreditProposal";
import SelectFinancialServices from "@repo/core/screens/ProposalEffectiveFlows/Credit/SelectFinancialService";
import SelectProduct from "@repo/core/screens/ProposalEffectiveFlows/SelectProduct";
import SelectServicePoint from "@repo/core/screens/ProposalEffectiveFlows/SelectServicePoint";

import CompleteRegistrationForm from "@repo/core/screens/ProposalEffectiveFlows/Fidelity/FidelityPersonalData";
import ReviewFidelityProposal from "@repo/core/screens/ProposalEffectiveFlows/Fidelity/ReviewFidelityProposal";

import NewTransactionCaptureOptions from "@repo/core/screens/NewTransaction/NewTransactionCaptureOptions";
import NewTransactionFidelity from "@repo/core/screens/NewTransaction/NewTransactionFidelity";
import NewTransactionInstallments from "@repo/core/screens/NewTransaction/NewTransactionInstallments";
import NewTransactionPaymentOptions from "@repo/core/screens/NewTransaction/NewTransactionPaymentOptions";
import NewTransactionIdentity from "@repo/core/screens/NewTransaction/NewTransactionIdentity";
import NewTransactionValue from "@repo/core/screens/NewTransaction/NewTransactionValue";
import NewTransactionReview from "@repo/core/screens/NewTransaction/NewTransactionReview";
import NewTransactionConfirm from "@repo/core/screens/NewTransaction/NewTransactionConfirm";
import NewTransactionReceipt from "@repo/core/screens/NewTransaction/NewTransactionReceipt";
import NewTransactionQRCode from "@repo/core/screens/NewTransaction/NewTransactionQRCode";

import InoviceDataForm from "@repo/core/screens/ProposalEffectiveFlows/Credit/InvoiceDataForm";
import PersonalReferenceForm from "@repo/core/screens/ProposalEffectiveFlows/Credit/PersonalReferenceForm";
import ProposalEffectiveSuccess from "@repo/core/screens/ProposalEffectiveFlows/ProposalEffectiveSuccess";

import Reports from "@repo/core/screens/Reports";
import AnalysedProposals from "@repo/core/screens/Reports/screens/AnalysedProposals";
import ApprovalTypes from "@repo/core/screens/Reports/screens/ApprovalTypes";
import AttendantsReport from "@repo/core/screens/Reports/screens/AttendantsReport";
import GeneralReport from "@repo/core/screens/Reports/screens/GeneralReport";
import SalesByStoreReport from "@repo/core/screens/Reports/screens/SalesByStoreReport";
import MonthlySalesReport from "@repo/core/screens/Reports/screens/MonthlySalesReport";
import OverdueWalletReport from "@repo/core/screens/Reports/screens/OverdueWalletReport";
import ReasonDenialReport from "@repo/core/screens/Reports/screens/ReasonDenialReport";

import { WithPermission } from "@repo/core/components/routes/WithPermission";
import { PermissionsGroup } from "@repo/core/constants/permissions";
import { BiometryFinished } from "../pages/Biometry";
import ProposalsViewInfo from "@repo/core/screens/Proposals/screens/ProposalsViewInfo";

import { Draft } from "../pages/Draft";
import { CreditTableHome } from "../pages/CreditTable";
import { SendToCreditTable } from "../pages/CreditTable/sendCreditTable";
import { ProposalsList } from "../pages/Proposals/list";
import { FEATURE_FLAGS } from "@repo/core/constants/featureFlags";

export const SignedInRoutes = () => {
  return (
    <Routes>
      {/* LAYOUT FULL DASHBOARD TEMPLATE */}
      <Route
        element={
          <AuthLayout>
            <Outlet />
          </AuthLayout>
        }
      >
        <Route path={ROUTES.home} element={<Home />} />
        <Route
          path={ROUTES.sales}
          element={
            <WithPermission permissions={PermissionsGroup.sales}>
              <Sales />
            </WithPermission>
          }
        />

        <Route path={ROUTES.proposals} element={<ProposalsList />} />
        <Route path={ROUTES.draftHome} element={<Draft />} />

        <Route path={ROUTES.creditTableHome} element={<CreditTableHome />} />

        <Route path={ROUTES.transactions} element={<Transactions />} />
        <Route path={ROUTES.reports} element={<Reports />} />
        <Route
          path={ROUTES.reportAnalysedProposals}
          element={<AnalysedProposals />}
        />
        <Route path={ROUTES.reportApprovalTypes} element={<ApprovalTypes />} />
        <Route path={ROUTES.reportAttendants} element={<AttendantsReport />} />
        <Route
          path={ROUTES.reportGeneralProposals}
          element={<GeneralReport />}
        />
        <Route
          path={ROUTES.reportSalesByStore}
          element={<SalesByStoreReport />}
        />
        <Route
          path={ROUTES.reportMonthlySales}
          element={<MonthlySalesReport />}
        />
        <Route
          path={ROUTES.reportOverdueWallet}
          element={<OverdueWalletReport />}
        />
        <Route
          path={ROUTES.reportReasonDenial}
          element={<ReasonDenialReport />}
        />
        <Route path={ROUTES.support} element={<Support />} />
      </Route>

      {/* LAYOUT WITH TOP MENU ONLY */}
      <Route
        element={
          <AuthLayout showSideMenu={false}>
            <Outlet />
          </AuthLayout>
        }
      >
        <Route path={ROUTES.profile} element={<Profile />} />
      </Route>

      {/* SCREENS WITHOUT LAYOUT */}

      <Route path={ROUTES.welcome} element={<WebWelcome />} />
      <Route path={ROUTES.biometryValidation} element={<BiometryFinished />} />

      <Route
        path={ROUTES.sendCreditTable}
        element={
          FEATURE_FLAGS.enableCreditTable ? (
            <SendToCreditTable />
          ) : (
            <Navigate to={ROUTES.proposals} replace />
          )
        }
      />

      <Route path={ROUTES.proposalsDone} element={<Proposals.ProposalDone />} />
      <Route
        path={ROUTES.proposalsValidToken}
        element={<Proposals.ValidToken />}
      />

      <Route
        path={ROUTES.proposalsInvalidToken}
        element={<Proposals.InvalidToken />}
      />
      {/* PRE PROPOSALS SCREENS */}
      <Route
        path={ROUTES.preProposalsInfoSecurity}
        element={<PreProposalsInfoSecurityScreen />}
      />
      <Route
        path={ROUTES.preProposalsPhoneNumber}
        element={<PreProposalsPhoneNumberScreen />}
      />
      <Route
        path={ROUTES.preProposalsConfirmToken}
        element={<PreProposalsConfirmTokenScreen />}
      />
      <Route
        path={ROUTES.preProposalsBiometryValidation}
        element={<PreProposalsBiometryValidationScreen />}
      />

      <Route
        path={ROUTES.preProposalsSelectProduct}
        element={<PreProposalsSelectProductScreen />}
      />
      <Route
        path={ROUTES.preProposalsSelectFinancialService}
        element={<PreProposalsSelectFinancialServiceScreen />}
      />
      <Route
        path={ROUTES.preProposalsSelectServicePoint}
        element={<PreProposalsSelectServicePointScreen />}
      />
      <Route
        path={ROUTES.preProposalsSelectAttendant}
        element={<PreProposalsSelectAttendandScreen />}
      />
      <Route
        path={ROUTES.preProposalsVerifyInformations}
        element={<PreProposalsVerifyInformationsScreen />}
      />
      <Route
        path={ROUTES.preProposalsSelectDocuments}
        element={<PreProposalSelectDocuments />}
      />
      <Route
        path={ROUTES.preProposalsCaptureDocument}
        element={<PreProposalCaptureDocumentScreen />}
      />
      {/*Profile Screens*/}

      <Route path={ROUTES.proposalsViewInfo} element={<ProposalsViewInfo />} />

      <Route path={ROUTES.editProfile} element={<EditProfile />} />
      <Route path={ROUTES.changePassword} element={<ChangePassword />} />

      {/* Transactions Screens */}
      <Route
        path={ROUTES.cancelTransactionOptions}
        element={<CancelTransactionOptions />}
      />

      <Route path={ROUTES.cancelTransaction} element={<CancelTransaction />} />
      {/* Receipt Screens */}
      <Route
        path={ROUTES.selectSecondCopyOfReceipt}
        element={<SelectSecondCopyOfReceipt />}
      />
      <Route
        path={ROUTES.secondCopyOfReceipt}
        element={<SecondCopyOfReceipt />}
      />
      <Route path={ROUTES.closingOfTheDay} element={<ClosingOfTheDay />} />

      {/* Withdraw Screens */}
      <Route
        path={ROUTES.emergencyWithdrawOptions}
        element={<EmergencyWithdrawOptions />}
      />
      <Route path={ROUTES.emergencyWithdraw} element={<EmergencyWithdraw />} />
      <Route
        path={ROUTES.emergencyWithdrawConfirm}
        element={<EmergencyWithdrawConfirm />}
      />
      <Route
        path={ROUTES.emergencyWithdrawReceipt}
        element={<EmergencyWithdrawReceipt />}
      />
      {/* Consult Limits Screens */}
      <Route
        path={ROUTES.consultLimitsVerifyIdentity}
        element={<ConsultLimitsVerifyIdentity />}
      />
      <Route
        path={ROUTES.consultLimitsReceipt}
        element={<ConsultLimitsReceipt />}
      />
      {/* Invoice Payment Screens */}
      <Route
        path={ROUTES.invoicePaymentOptions}
        element={<InvoicePaymentOptions />}
      />
      <Route path={ROUTES.invoicePayment} element={<InvoicePayment />} />
      <Route path={ROUTES.invoicePaymentConfirm} element={<ConfirmPayment />} />
      <Route path={ROUTES.invoicePaymentReceipt} element={<InvoiceReceipt />} />

      {/* Simulate Installments Screens */}
      <Route
        path={ROUTES.simulateInstallmentsOptions}
        element={<SimulateInstallmentsOptions />}
      />
      <Route
        path={ROUTES.simulateInstallmentsValue}
        element={<SimulateInstallmentsValue />}
      />
      <Route
        path={ROUTES.simulateInstallments}
        element={<SimulateInstallments />}
      />
      <Route
        path={ROUTES.simulateInstallmentsReceipt}
        element={<SimulateInstallmentsReceipt />}
      />
      {/* Credit Proposal Form */}
      <Route
        path={ROUTES.creditProposalPersonalData}
        element={<PersonalDataForm />}
      />
      <Route
        path={ROUTES.creditProposalAddress}
        element={<AddressDataForm />}
      />
      <Route
        path={ROUTES.creditProposalProfessionData}
        element={<ProfessionDataForm />}
      />
      <Route
        path={ROUTES.creditProposalInvoiceData}
        element={<InoviceDataForm />}
      />
      <Route
        path={ROUTES.creditProposalPersonalReference}
        element={<PersonalReferenceForm />}
      />
      <Route
        path={ROUTES.creditProposalReview}
        element={<ReviewCreditProposal />}
      />
      <Route
        path={ROUTES.creditProposalDetails}
        element={<DetailsCreditProposal />}
      />
      <Route
        path={ROUTES.creditProposalSelectFinancialService}
        element={<SelectFinancialServices />}
      />
      <Route
        path={ROUTES.creditProposalSelectProduct}
        element={<SelectProduct />}
      />
      <Route
        path={ROUTES.creditProposalSelectServicePoint}
        element={<SelectServicePoint />}
      />

      {/* Fidelity Proposal Form */}
      <Route
        path={ROUTES.fidelityProposalCompleteRegistration}
        element={<CompleteRegistrationForm />}
      />
      <Route
        path={ROUTES.fidelityProposalReview}
        element={<ReviewFidelityProposal />}
      />

      {/* New Transaction Screens */}
      <Route
        path={ROUTES.newTransactionCaptureOptions}
        element={<NewTransactionCaptureOptions />}
      />
      <Route
        path={ROUTES.newTransactionIdentity}
        element={<NewTransactionIdentity />}
      />
      <Route
        path={ROUTES.newTransactionValue}
        element={<NewTransactionValue />}
      />
      <Route
        path={ROUTES.newTransactionFidelityOptions}
        element={<NewTransactionFidelity />}
      />
      <Route
        path={ROUTES.newTransactionPaymentOptions}
        element={<NewTransactionPaymentOptions />}
      />
      <Route
        path={ROUTES.newTransactionInstallments}
        element={<NewTransactionInstallments />}
      />
      <Route
        path={ROUTES.newTransactionReview}
        element={<NewTransactionReview />}
      />
      <Route
        path={ROUTES.newTransactionConfirm}
        element={<NewTransactionConfirm />}
      />
      <Route
        path={ROUTES.newTransactionReceipt}
        element={<NewTransactionReceipt />}
      />
      <Route
        path={ROUTES.newTransactionQRCode}
        element={<NewTransactionQRCode />}
      />

      {/* Proposal Implementation */}
      <Route
        path={ROUTES.proposalImplementationInvoiceDate}
        element={<InoviceDataForm />}
      />
      <Route
        path={ROUTES.proposalImplementationPersonalReference}
        element={<PersonalReferenceForm />}
      />
      <Route
        path={ROUTES.proposalEffectiveSuccess}
        element={<ProposalEffectiveSuccess />}
      />

      <Route path="*" element={<Navigate to={ROUTES.home} />} />
    </Routes>
  );
};
